import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonText: {
    marginLeft: '7px'
  },
  modifyButton: {
    marginRight: '12px',
    marginLeft: '12px'
  },
  actionButtonGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  navigationGroup:{
    display: 'flex',
    alignItems: 'center'
  },
  titleHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  topHeaderIcon: {
    backgroundColor: theme.palette.grey.grey100,
    padding: "9px",
    borderRadius: "50%",
    marginBottom: "1rem",
    width: "55px",
    overflow: "visible",
  },
  archiveTitle: {
    fontSize: "18px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: theme.palette.grey.grey700,
    marginBottom: "8px",
  },
  archiveSubTitle: {
    fontSize: "14px",
    color: theme.palette.grey.grey500,
    marginBottom: "32px",
  }
}));

export default useStyles;
